module.exports = __webpack_public_path__ + "4e6f03d4705627b0fee7811de8323165.png";